module.exports = __webpack_public_path__ + "img/157-Skai Woodec Turner Oak Tofee.jpg";